import { type TimeOfDay } from "$lib/features/_other/timeOfDay.enum";
import { type CityFeature } from "$lib/features/cityFeature/cityFeature.type";
import type { ImageDetails } from "$lib/features/image/imageDetails.type";
import type { Route } from "$lib/features/route/route.type";
import type { TourStop } from "$lib/features/tour/stop/tourStop.type";

export interface Tour {
    route: Route;
    why: string;
    timeOfDay: TimeOfDay;
    proTips: string[];
    stops: TourStop[];
    feature: CityFeature;
}

export function findFirstTourStopImage(tour: Tour): ImageDetails | undefined {
    for (const stop of tour.stops) {
        const image = stop.primary?.images[0] ?? stop.images[0];
        if (image) return image;
    }
    return undefined;
}